import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CompanyTierState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: CompanyTierState = {
  data: [],
  isLoading: false,
  error: null,
};

const companyTierSlice = createSlice({
  name: 'companyTiers',
  initialState,
  reducers: {
    setCompanyTier: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setCompanyTierLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setCompanyTierError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setCompanyTier, setCompanyTierLoading, setCompanyTierError } = companyTierSlice.actions;

export default companyTierSlice.reducer;
